export * from './EmbeddedStyle';
